<billing-summary *ngIf="showPaidFullSidebar$" 
  [visible]="showPaidFullSidebar$" [planSummarydata]="planSummary$" [isCartFlow]="isCartFlow"
    (closeSidePopup)="CloseBillingSummary($event)" (addToCart)="AddToCart($event)">
</billing-summary>

<pos-billing-summary *ngIf="showPosBilling" 
  [visible]="showPosBilling" [posSummaryData]="planSummary$" [isCartFlow]="isCartFlow" (addToCart)="AddToCart($event)"
   (closeSidePopup)="CloseBillingSummary($event)">
</pos-billing-summary>


<payment-status-timeline *ngIf="showPaymentStatusSidebar$" [visible]="showPaymentStatusSidebar$" [uuid]="uuid"
  (hidePaymentSummaryPopup)="HidePaymentSummary($event)" (GoToClientSubscription)="GoToClientDetails($event)"
  [isPayment]="ispayment" >
</payment-status-timeline>
